import trackProductEvent from '../../utils/trackProductEvent';

const eventName = 'ungated.pdp';
const canonicalName = 'pdp';
const actionDetail = 'ungated_shop';

export const trackCarouselSeenInViewport = ({
  categories,
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking,
  subSource,
}) => {
  if (skipEventTracking) {
    return;
  }

  const actionType = 'view';
  const actionName = 'category_carousel_view';
  const directBuyContext = {
    categories: categories?.map(card => ({
      id: card.category?.id,
      category_name: card.title,
    })),
    source: 'ungated_shop',
    sub_source: subSource,
  };

  const metricsTags = {
    product_business_line: productBusinessLine,
    client_business_line: clientBusinessLine,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};

export const trackSeeMoreCategoriesClick = ({
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking,
  subSource,
}) => {
  if (skipEventTracking) {
    return;
  }

  const actionType = 'click';
  const actionName = 'category_carousel_view_see_more';
  const directBuyContext = {
    source: 'ungated_shop',
    sub_source: subSource,
  };

  const metricsTags = {
    product_business_line: productBusinessLine,
    client_business_line: clientBusinessLine,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};

export const trackCarouselScroll = ({
  categoryId,
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking,
  subSource,
}) => {
  if (skipEventTracking) {
    return;
  }

  const actionType = 'scroll';
  const actionName = 'scroll_category_carousel';
  const directBuyContext = {
    category_id: categoryId,
    source: 'ungated_shop',
    sub_source: subSource,
  };

  const metricsTags = {
    product_business_line: productBusinessLine,
    client_business_line: clientBusinessLine,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};

export const trackCategoryClick = ({
  categoryId,
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking,
  subSource,
}) => {
  if (skipEventTracking) {
    return;
  }

  const actionType = 'click';
  const actionName = 'click_category_carousel_card';
  const directBuyContext = {
    category_id: categoryId,
    source: 'ungated_shop',
    sub_source: subSource,
  };

  const metricsTags = {
    product_business_line: productBusinessLine,
    client_business_line: clientBusinessLine,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};

export const trackCategoryEndCardView = ({
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking,
  subSource,
}) => {
  if (skipEventTracking) {
    return;
  }

  const actionType = 'view';
  const actionName = 'category_carousel_end_card';
  const directBuyContext = {
    source: 'ungated_shop',
    sub_source: subSource,
  };

  const metricsTags = {
    product_business_line: productBusinessLine,
    client_business_line: clientBusinessLine,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};

export const trackCategoryEndCardClick = ({
  clientBusinessLine,
  productBusinessLine,
  skipEventTracking,
  subSource,
}) => {
  if (skipEventTracking) {
    return;
  }

  const actionType = 'click';
  const actionName = 'category_carousel_end_card';
  const directBuyContext = {
    source: 'ungated_shop',
    sub_source: subSource,
  };

  const metricsTags = {
    product_business_line: productBusinessLine,
    client_business_line: clientBusinessLine,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
    metricsTags,
  });
};
